import AdminMetricsComponent from 'components/metrics-admin'
import { SchoolUsersProps } from 'utils/types'

function Index({ schoolUsers }: { schoolUsers?: SchoolUsersProps | null }): JSX.Element {
  const { schoolStats, students = [] } = schoolUsers ?? {}
  return <AdminMetricsComponent schoolStats={schoolStats} students={students} />
}

export default Index
